import { Award, Flame, Crown, Zap, BadgeCheck } from "lucide-react";

// Achievement / referral badges granted server-side (present on the user object as `badges`
// and in the referrals payload). Rendered as avatar corner flair + profile/referral chips.
export const BADGE_META = {
  connector: { label: "Connector", Icon: Award, color: "#3591F4", chip: "border-bloq-blue/40 bg-bloq-blue/15 text-bloq-blue" },
  champion: { label: "Champion", Icon: Crown, color: "#8B5CF6", chip: "border-bloq-purple/40 bg-bloq-purple/15 text-bloq-purple" },
  starter: { label: "Starter", Icon: Zap, color: "#01FABD", chip: "border-bloq-mint/40 bg-bloq-mint/15 text-bloq-mint" },
  founding: { label: "Founding Member", Icon: Flame, color: "#01FABD", chip: "border-bloq-mint/40 bg-bloq-mint/15 text-bloq-mint" },
  founding_member: { label: "Founding Member", Icon: Flame, color: "#01FABD", chip: "border-bloq-mint/40 bg-bloq-mint/15 text-bloq-mint" },
};

export const badgeMeta = (id) =>
  BADGE_META[id] || {
    label: String(id || "").replace(/_/g, " "),
    Icon: BadgeCheck,
    color: "#9CA3AF",
    chip: "border-white/20 bg-white/10 text-white/80",
  };

// Highest-priority badge for the single avatar-corner slot.
const PRIORITY = ["founding", "founding_member", "champion", "connector", "starter"];
export const topBadge = (badges = []) => {
  for (const p of PRIORITY) if (badges.includes(p)) return p;
  return badges.find((b) => BADGE_META[b]) || badges[0] || null;
};
